export default function MeetingCard({ room, data }) {
    return <div className="meeting-card">
        <div className="meeting-card__image" style={{ backgroundImage: `url('${data?.background}')`}}>
            <div className="meeting-card__overlay"></div>
            <div className="meeting-card__details">
                <h1 className="meeting-card__name">{ data?.name }</h1>
                <div className="meeting-card__content">
                    <div className="meeting-card__inner">
                        <p className="meeting-card__description">£{room?.price_per_hour}+ VAT Per hour</p>
                        <div className="meeting-card__points">
                            { room?.content?.features?.map((feature, index) => {
                                return (
                                    <div key={index} className="meeting-card__point">
                                        <div className="meeting-card-point__point"></div>
                                        { feature?.title }
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="meeting-card__buttons">
            <a href={data?.slug} className="meeting-card__button meeting-card__button--details">Details</a>
            <a href={data?.slug} className="meeting-card__button meeting-card__button--book">Book</a>
        </div>
    </div>
}